import {
  SURFACE_COLORS,
  SURFACE_EMPHASES,
  SURFACE_PALETTE_COLORS,
  SURFACE_STATUS_COLORS,
} from '@ankhorage/surface/color';

export type { ZoraColor, ZoraEmphasis, ZoraPaletteColor, ZoraStatusColor } from '../../types/theme';

export const ZORA_PALETTE_COLORS = SURFACE_PALETTE_COLORS;
export const ZORA_STATUS_COLORS = SURFACE_STATUS_COLORS;
export const ZORA_COLORS = SURFACE_COLORS;
export const ZORA_EMPHASES = SURFACE_EMPHASES;
